// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../components/Select/Select.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form__RKVBJ {
    width: 700px;
    /*padding: 40px var(--container-padding) 100px;*/
    margin: 80px auto;
    border: 0.5px solid var(--dark-grey);
    border-radius: 3px;
    background: #fff;
}

.styles_header__sHU5R {
    padding: 23px 35px;
    border-bottom: 1px solid var(--light-grey);
}

.styles_headerRow__V0zat {
    display: grid;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: 1fr 110px;
    grid-gap: 30px;
}

.styles_headerRow__V0zat:not(:last-child) {
    margin-bottom: 18px;
}

.styles_content__-nTjl {
    padding: 25px 35px 35px;
}

.styles_content__-nTjl.styles_block__Mi2A7 {
    padding-top: 40px;
    padding-bottom: 60px;
}

.styles_content__-nTjl.styles_grid__ronnf {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 40px;
    grid-row-gap: 40px;
}

.styles_fullWidth__nvsm3 {
    grid-column: 1 / -1;
}

.styles_content__-nTjl.styles_block__Mi2A7 {
    text-align: center;
}

.styles_title__fbG9a {
    margin: auto 0;
}

.styles_label__XJegS {
    --input-h: 44px;
    /*width: 699px;*/
    /*max-width: 50%;*/
    /*margin-left: 16px;*/
    /*transition: width 200ms;*/
    /*margin-bottom: 14px;*/
}

.styles_placeholder__cCFuP {
    display: block;
    font-size: 14px;
    transition:
        color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
        transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    /*cursor: text;*/
    pointer-events: none;
    margin-bottom: 10px;
    position: relative;
    z-index: 2;
}

.styles_input__Xc9RT {
    background: var(--white-active);
    border: 0.5px solid var(--primary-color);
    width: 100%;
    padding: 12px 20px;
    height: 44px;
    transition: height 200ms;
    border-radius: 3px;
    font-size: 16px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 16;
}

.styles_input__Xc9RT:hover {
    border-color: var(--primary-color);
}

.styles_selectControl__QK9Fq {
    padding-left: 0;
}

.styles_selectControlFocused__6o7vC {
    border-color: var(--primary-color-active);
}

.styles_selectValueContainer__\\+mREH {
    padding: 0 20px;
    display: flex;
    align-items: center;
}

.styles_selectPlaceholder__2g3UY {
    color: #757575;
}

.styles_selectSingleValue__XKQsd {
    color: var(--black);
    margin: 0;
}

.styles_selectInput__9tKtX {
    margin: 0;
    padding: 0;
}

.styles_controlTop__c-ZUY {
    border-top-color: var(--white-active) !important;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.styles_controlBottom__qZJk3 {
    border-bottom-color: var(--white-active) !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.styles_selectMenu__E6LX2 {
    background: var(--white-active);
    border: 0.5px solid var(--primary-color-active);
    border-radius: 0;
    z-index: 15;
}

.styles_selectMenuList__4DnIH {
    background: var(--white-active);
    padding: 1px;
}

.styles_selectOption__-StiR {
    padding: 3px 16px;
    border: 4px solid var(--white-active);
    transition: background-color 0.4s;
    border-radius: 8px;
    cursor: pointer !important;
    background: var(--white-active);
    color: var(--black);
}

.styles_selectOptionSelected__Mi4sS {
    background: rgba(214, 214, 214, 0.5);
    border-color: var(--white-active);
}

.styles_selectOptionFocused__LEuTV {
    background: rgba(214, 214, 214, 0.3);
    border-color: var(--white-active);
}

.styles_selectMenuTop__7f44l {
    border-bottom: none;
    background: var(--white-active);
}

.styles_selectMenuBottom__FRWyh {
    border-top: none;
    background: var(--white-active);
}

.styles_focused__w-8mK .styles_placeholder__cCFuP {
}

.styles_focused__w-8mK .styles_input__Xc9RT,
.styles_focused__w-8mK .styles_selectControl__QK9Fq {
    border-color: var(--primary-color-active);
}

textarea.styles_input__Xc9RT {
    height: 128px;
}

.styles_btnWrapper__dXDAJ {
    width: 100%;
    text-align: center;
}

.styles_btnWrapper__dXDAJ:not(:first-child) {
    margin-top: 40px;
}

.styles_responseHeader__yCcMV {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-gap: 15px;
}

.styles_responseHeader__yCcMV img {
    width: 40px;
}

.styles_responseSubheader__ccZbI {
    margin: 40px auto 253px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_form__RKVBJ {
        width: 681px;
    }

    .styles_header__sHU5R {
        padding: 20px 20px;
    }

    .styles_content__-nTjl {
        padding: 20px 20px 35px;
    }

    .styles_content__-nTjl.styles_block__Mi2A7 {
        padding-bottom: 60px;
    }

    .styles_content__-nTjl.styles_grid__ronnf {
        grid-row-gap: 20px;
    }

    .styles_btnWrapper__dXDAJ:not(:first-child) {
        margin-top: 20px;
    }

    .styles_responseSubheader__ccZbI {
        margin-bottom: 180px;
    }

    .styles_label__XJegS {
        --input-h: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact/styles.module.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,gDAAgD;IAChD,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf;;sDAEkD;IAClD,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IAEI,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gDAAgD;IAChD,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,mDAAmD;IACnD,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IAEI,+BAA+B;IAC/B,+CAA+C;IAC/C,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,kBAAkB;IAClB,0BAA0B;IAC1B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IAEI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IAEI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;AACA;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.form {\n    width: 700px;\n    /*padding: 40px var(--container-padding) 100px;*/\n    margin: 80px auto;\n    border: 0.5px solid var(--dark-grey);\n    border-radius: 3px;\n    background: #fff;\n}\n\n.header {\n    padding: 23px 35px;\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.headerRow {\n    display: grid;\n    align-items: center;\n    justify-content: space-between;\n    grid-template-columns: 1fr 110px;\n    grid-gap: 30px;\n}\n\n.headerRow:not(:last-child) {\n    margin-bottom: 18px;\n}\n\n.content {\n    padding: 25px 35px 35px;\n}\n\n.content.block {\n    padding-top: 40px;\n    padding-bottom: 60px;\n}\n\n.content.grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n}\n\n.fullWidth {\n    grid-column: 1 / -1;\n}\n\n.content.block {\n    text-align: center;\n}\n\n.title {\n    margin: auto 0;\n}\n\n.label {\n    --input-h: 44px;\n    /*width: 699px;*/\n    /*max-width: 50%;*/\n    /*margin-left: 16px;*/\n    /*transition: width 200ms;*/\n    /*margin-bottom: 14px;*/\n}\n\n.placeholder {\n    display: block;\n    font-size: 14px;\n    transition:\n        color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n        transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    /*cursor: text;*/\n    pointer-events: none;\n    margin-bottom: 10px;\n    position: relative;\n    z-index: 2;\n}\n\n.input {\n    background: var(--white-active);\n    border: 0.5px solid var(--primary-color);\n    width: 100%;\n    padding: 12px 20px;\n    height: 44px;\n    transition: height 200ms;\n    border-radius: 3px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 16;\n}\n\n.input:hover {\n    border-color: var(--primary-color);\n}\n\n.selectControl {\n    composes: input;\n    padding-left: 0;\n}\n\n.selectControlFocused {\n    border-color: var(--primary-color-active);\n}\n\n.selectValueContainer {\n    padding: 0 20px;\n    display: flex;\n    align-items: center;\n}\n\n.selectPlaceholder {\n    color: #757575;\n}\n\n.selectSingleValue {\n    color: var(--black);\n    margin: 0;\n}\n\n.selectInput {\n    margin: 0;\n    padding: 0;\n}\n\n.controlTop {\n    border-top-color: var(--white-active) !important;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.controlBottom {\n    border-bottom-color: var(--white-active) !important;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.selectMenu {\n    composes: dropdownMenu from '../../components/Select/Select.module.css';\n    background: var(--white-active);\n    border: 0.5px solid var(--primary-color-active);\n    border-radius: 0;\n    z-index: 15;\n}\n\n.selectMenuList {\n    background: var(--white-active);\n    padding: 1px;\n}\n\n.selectOption {\n    padding: 3px 16px;\n    border: 4px solid var(--white-active);\n    transition: background-color 0.4s;\n    border-radius: 8px;\n    cursor: pointer !important;\n    background: var(--white-active);\n    color: var(--black);\n}\n\n.selectOptionSelected {\n    background: rgba(214, 214, 214, 0.5);\n    border-color: var(--white-active);\n}\n\n.selectOptionFocused {\n    background: rgba(214, 214, 214, 0.3);\n    border-color: var(--white-active);\n}\n\n.selectMenuTop {\n    composes: dropdownTop from '../../components/Select/Select.module.css';\n    border-bottom: none;\n    background: var(--white-active);\n}\n\n.selectMenuBottom {\n    composes: dropdownBottom from '../../components/Select/Select.module.css';\n    border-top: none;\n    background: var(--white-active);\n}\n\n.focused .placeholder {\n}\n\n.focused .input,\n.focused .selectControl {\n    border-color: var(--primary-color-active);\n}\n\ntextarea.input {\n    height: 128px;\n}\n\n.btnWrapper {\n    width: 100%;\n    text-align: center;\n}\n\n.btnWrapper:not(:first-child) {\n    margin-top: 40px;\n}\n\n.responseHeader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    grid-gap: 15px;\n}\n\n.responseHeader img {\n    width: 40px;\n}\n\n.responseSubheader {\n    margin: 40px auto 253px;\n}\n\n@media screen-md-max {\n    .form {\n        width: 681px;\n    }\n\n    .header {\n        padding: 20px 20px;\n    }\n\n    .content {\n        padding: 20px 20px 35px;\n    }\n\n    .content.block {\n        padding-bottom: 60px;\n    }\n\n    .content.grid {\n        grid-row-gap: 20px;\n    }\n\n    .btnWrapper:not(:first-child) {\n        margin-top: 20px;\n    }\n\n    .responseSubheader {\n        margin-bottom: 180px;\n    }\n\n    .label {\n        --input-h: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"form": `styles_form__RKVBJ`,
	"header": `styles_header__sHU5R`,
	"headerRow": `styles_headerRow__V0zat`,
	"content": `styles_content__-nTjl`,
	"block": `styles_block__Mi2A7`,
	"grid": `styles_grid__ronnf`,
	"fullWidth": `styles_fullWidth__nvsm3`,
	"title": `styles_title__fbG9a`,
	"label": `styles_label__XJegS`,
	"placeholder": `styles_placeholder__cCFuP`,
	"input": `styles_input__Xc9RT`,
	"selectControl": `styles_selectControl__QK9Fq styles_input__Xc9RT`,
	"selectControlFocused": `styles_selectControlFocused__6o7vC`,
	"selectValueContainer": `styles_selectValueContainer__+mREH`,
	"selectPlaceholder": `styles_selectPlaceholder__2g3UY`,
	"selectSingleValue": `styles_selectSingleValue__XKQsd`,
	"selectInput": `styles_selectInput__9tKtX`,
	"controlTop": `styles_controlTop__c-ZUY`,
	"controlBottom": `styles_controlBottom__qZJk3`,
	"selectMenu": `styles_selectMenu__E6LX2 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownMenu"]}`,
	"selectMenuList": `styles_selectMenuList__4DnIH`,
	"selectOption": `styles_selectOption__-StiR`,
	"selectOptionSelected": `styles_selectOptionSelected__Mi4sS`,
	"selectOptionFocused": `styles_selectOptionFocused__LEuTV`,
	"selectMenuTop": `styles_selectMenuTop__7f44l ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownTop"]}`,
	"selectMenuBottom": `styles_selectMenuBottom__FRWyh ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownBottom"]}`,
	"focused": `styles_focused__w-8mK`,
	"btnWrapper": `styles_btnWrapper__dXDAJ`,
	"responseHeader": `styles_responseHeader__yCcMV`,
	"responseSubheader": `styles_responseSubheader__ccZbI`
};
export default ___CSS_LOADER_EXPORT___;
